import '@/api/dms/setup'; // Side-effect: shared features use DMS client
import '@/api/platform/setup'; // Side-effect: platform features use platform client
import { Building, FileText } from 'lucide-react';
import { createPlatformNavItems } from '@/config/nav';
import { createPlatformCommandProviders } from '@/features/platform/command-providers';
import { usePermissionResources } from '@/features/platform/hooks/usePermissionResources';
import { useNotificationBadgeCount } from '@/features/platform/notifications/hooks/useNotifications';
import { getPlatformRoutes } from '@/routes/platform';
import type { AppConfig } from './types';

export const platformConfig: AppConfig = {
  id: 'platform',
  name: 'Pill Connect Platform',
  shortName: 'Pill Connect',
  logoAriaLabel: 'Pill Connect logo',
  sentry: { project: 'atlas-platform-frontend' },
  searchEnabled: false,
  navItems: createPlatformNavItems({
    notificationCount: {
      useCount: useNotificationBadgeCount,
      variant: 'primary',
    },
  }),
  getRoutes: getPlatformRoutes,
  permissionSections: [
    {
      resourceType: 'organization',
      label: 'Organizations',
      icon: Building,
      children: [{ resourceType: 'trial', label: 'Trials', icon: FileText }],
    },
  ],
  usePermissionResources,
  commandProviders: createPlatformCommandProviders,
};
